export const SWITCH_INPUT_MODE = 'onboarding/addTeamMembers/SWITCH_INPUT_MODE'
export const INVITATION_ERROR = 'onboarding/addTeamMembers/INVITATION_ERROR'
